export default __webpack_public_path__ + "static/media/process-err-mobile.b48a3c92.svg";